/**
 * Трейдинг · окно 3, заход 2 — логика экрана (⛔ не подачи и не отбора слов).
 *
 * Набор доменных карточек (терминал · правила проп-фирмы · рынок · переписка с
 * поддержкой) человек включает себе САМ. Кому его показывать, решать не надо:
 * решением владельца 20.08 трейдинг публичен — он доступен каждому, кто вошёл в
 * приложение. Платными вместо него стали книги и транскрибация.
 *
 * Что умеет ЭКРАН и что живёт здесь:
 *   • понять, включён ли набор (⚠ значение приезжает то числом, то строкой — та же
 *     грабля, что у `audio_autoplay` и напоминаний);
 *   • собрать ЧЕСТНОЕ предупреждение о сложности — с ЕГО цифрой, а не общим «это
 *     сложно»: замер 20.08 показал, что живые фразы домена на 83% состоят из слов
 *     первой тысячи, а вторая и третья добавляют всего +3%;
 *   • решить, показывать ли предложение включить (⭐ ровно один раз).
 *
 * ⛔ Ни одной своей цифры: сколько слов в наборе, сколько осталось до базы и какая
 * дневная доза — приезжает из ядра в `/me.trading`. ⛔ Включённостью владеет ядро
 * (`seed_data.set_trading` правит `subgroups.is_active`), витрина только шлёт PATCH.
 */

/** Доля слов домена, приходящаяся на первую тысячу частотных (замер 20.08). */
export const BASE_SHARE_PCT = 83;

export type TradingBase = {
  band: number; left: number; total: number; started: number; ready: boolean;
};

export type TradingState = {
  exists: boolean; enabled: boolean; words: number;
  daily_quota?: number; asked?: boolean; base?: TradingBase;
};

/** Включён ли набор. ⚠ Приходит и числом, и строкой — приводим одинаково. */
export function isOn(value: unknown): boolean {
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") return value === "1" || value === "true";
  return Boolean(value);
}

/** Падеж слова «слово»: 1 слово · 2 слова · 5 слов. */
export function plWords(n: number): string {
  const a = Math.abs(n) % 100, b = a % 10;
  if (a > 10 && a < 20) return "слов";
  if (b > 1 && b < 5) return "слова";
  if (b === 1) return "слово";
  return "слов";
}

/**
 * ⭐⭐ Предупреждение о сложности — главный текст этого экрана.
 *
 * Порог базы НЕ запрет: решение владельца 20.08 — «предупреждать, но пускать».
 * Поэтому здесь возвращается текст, а не разрешение; кнопка работает всегда.
 */
export function warning(state: TradingState | null | undefined): string {
  const left = state?.base?.left ?? 0;
  if (!state?.base || left <= 0) {
    return `Базы хватает: первую тысячу частых слов вы уже начали. ` +
           `Фразы трейдинга на ${BASE_SHARE_PCT}% состоят именно из них.`;
  }
  return `Будет трудно: фразы трейдинга на ${BASE_SHARE_PCT}% состоят из первой ` +
         `тысячи частых слов, а вам из неё осталось ${left} ${plWords(left)}. ` +
         `Включить можно всё равно — просто новых слов в карточке будет два, а не одно.`;
}

/** Подпись под тумблером: сколько слов в наборе и как они придут. */
export function summary(state: TradingState | null | undefined): string {
  if (!state?.exists) return "Набор ещё не загружен.";
  const n = state.words || 0;
  const q = state.daily_quota || 0;
  const head = `В наборе ${n} ${plWords(n)}: терминал, правила проп-фирм, разбор ` +
               `сделок и переписка с поддержкой.`;
  if (!state.enabled) return `${head} Сейчас выключен — в занятии их нет.`;
  return `${head} Приходят по ${q} ${plWords(q)} в день, вперемешку с обычными.`;
}

/**
 * ⭐ Показывать ли предложение включить набор.
 *
 * Правило: спрашиваем РОВНО ОДИН РАЗ и только того, у кого набор есть. «Уже
 * спрашивали» выводится из САМОГО наличия строки `settings.trading_enabled`
 * (ядро отдаёт это флагом `asked`) — нового поля под это не заводили, ровно как
 * согласие на показ имени в окне 4. ⛔ Отказ — тоже ответ: второй раз не спрашиваем.
 */
export function shouldOffer(state: TradingState | null | undefined,
                            calibrationNeeded: boolean): boolean {
  if (!state?.exists) return false;      // набора нет — предлагать нечего
  if (calibrationNeeded) return false;   // ⭐ сперва калибровка, потом предложение
  return state.asked !== true;
}

/** Тексты предложения (показывается один раз, сразу после калибровки). */
export function offerTexts(state: TradingState | null | undefined) {
  return {
    title: "Учить английский трейдинга?",
    body: summary(state),
    warn: warning(state),
    yes: "Включить",
    no: "Не надо",
    foot: "Передумаете — тумблер всегда есть в настройках.",
  };
}

/* --- предложение в кабинете (показывается один раз) ------------------------ */

let answered = false;      // ответил в этом заходе — карточка уходит сразу

/** Показывать ли карточку-предложение прямо сейчас. */
export function offerVisible(state: TradingState | null | undefined,
                             calibrationNeeded: boolean): boolean {
  if (answered) return false;
  return shouldOffer(state, calibrationNeeded);
}

/** Разметка карточки-предложения. ⛔ Ни одной своей цифры — всё из `offerTexts`. */
export function offerCardHtml(state: TradingState | null | undefined): string {
  const t = offerTexts(state);
  const esc = (x: string) => x.replace(/[&<>"]/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c] as string));
  return (
    '<div class="card ask" id="tradeOffer">' +
      `<p class="h">${esc(t.title)}</p>` +
      `<p class="hsub">${esc(t.body)}</p>` +
      `<p class="footnote warn">${esc(t.warn)}</p>` +
      '<div class="askrow">' +
        `<button type="button" class="askbtn yes" id="tradeYes">${esc(t.yes)}</button>` +
        `<button type="button" class="askbtn no" id="tradeNo">${esc(t.no)}</button>` +
      "</div>" +
      `<p class="footnote">${esc(t.foot)}</p>` +
    "</div>"
  );
}

/** Отметить, что человек ответил (и «да», и «нет» — ответ). */
export function markAnswered(): void { answered = true; }
